import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, delay, retry, shareReplay, take } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
    providedIn: 'root'
})
export class AssignmentService {
    constructor(private httpClient: HttpClient, private appSettings: AppSettings) { }

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    getServiceLevels(): Observable<any> {
        let url = this.appSettings.apiBaseUrl() + `/Types/GetServiceLevels`
        return this.httpClient.get<any>(url, this.httpOptions)
        .pipe(
            retry({ count: 2, delay: 500}), shareReplay());
    }

    getCoordintorGroups(): Observable<any> {
        let url = this.appSettings.apiBaseUrl() + `/Types/GetCoordintorGroups`
        return this.httpClient.get<any>(url, this.httpOptions)
        .pipe(
            retry({ count: 2, delay: 500}), shareReplay());
    }

    getSundaySchoolServices(): Observable<any> {
        let url = this.appSettings.apiBaseUrl() + `/Events/GetSundaySchoolServices`
        return this.httpClient.get<any>(url, this.httpOptions)
        .pipe(
            retry({ count: 2, delay: 500}), shareReplay());
    }

    getProfileAssignments(isServantsOnly: boolean): Observable<any> {
        let url = this.appSettings.apiBaseUrl() + `/Profile/GetProfileAssignments?isServantsOnly=${isServantsOnly}`
        return this.httpClient.get<any>(url, this.httpOptions)
        .pipe(
            retry({ count: 2, delay: 500}), shareReplay());
    }

}